<template>
  <div>
    <div class="feedbackPage">
      <div
        class="head-topbar lite-page-top linebottom sticky"
        style="background: rgb(255, 255, 255);"
      >
        <div class="topbar-left" @click="goto('/jnt/center/feedback')">
          <i class="icon-arrow-left"></i>
        </div>
        <div class="topbar-main"><h4>反馈记录</h4></div>
      </div>

      <div>
        <div class="main_listing mt">
          <div class="listing-box">
            <div class="tomb-item tomb-item-famous" v-for="(item,index) in feedbackList" :key="index">
              <div class="item-a item-slide" style="border-radius: 6px;">
                <div class="item-desc" style="width: 100%; margin: 0px;">
                  <div class="title" style="font-size: 1.2rem; margin-bottom: 1.363rem;">
                    {{item.content}}
                  </div>
                  <div class="intro-bot">
                    <div class="pray-time">
                      <p>
                        <span><span>{{fmtDateTime(item.createDate)}}</span></span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="adm-infinite-scroll">
          <div><span>没有更多数据了</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'help',
  data() {
    return {
      hallId: null,
      feedbackList: [],
      feedbackTotal: 0,
    }
  },
  methods: {
    goto(str) {
      this.$router.push({ path: str })
    },
    fmtDateTime(value) {
      if (value) {
        return moment(value, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
      } else {
        return ''
      }
    },
    queryFeedbackPage(){
      var that=this
      this.$queryPage('MsgFeedback', { 
          myId: this.$store.getters.userId 
        }, ['id,dealStatus,content,createDate,dealResult,dealDate'],function(res) {
        that.$fill(that.feedbackList, res.data)
        that.feedbackTotal = res.total
      })
    }
  },
  mounted(){
    this.queryFeedbackPage()
  },
  created() {},
  watch: {},
}
</script>

<style>
*,
:after,
:before {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

input,
textarea {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
button,
input,
select,
textarea {
  -webkit-appearance: none;
}

input,
textarea {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
button,
input,
select,
textarea {
  -webkit-appearance: none;
}
.feedbackPage .btn-submit {
  padding-top: 15px;
}
.feedbackPage .btn-submit span {
  display: block;
  width: 100%;
  height: 3.6rem;
  background: #e4803c;
  color: #fff;
  text-align: center;
  line-height: 3.6rem;
  border-radius: 20px;
  font-size: 1.4rem;
}
.head-topbar.sticky {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
}
.head-topbar {
  display: flex;
  align-items: center;
  height: 3.8rem;
  background: #fff;
  position: fixed;
  width: 100%;
  z-index: 1;
}
.head-topbar .topbar-left {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.73333vw;
  position: absolute;
  left: 0.265rem;
  height: 100%;
  z-index: 10;
}
.head-topbar .topbar-left .icon-arrow-left {
  background: url(../../../assets/jnt/zjt1.png) no-repeat;
  background-size: 100%;
  display: inline-block;
  height: 1.363rem;
  width: 0.818rem;
}
.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
.head-topbar .topbar-main {
  flex: 1;
  color: #333;
  font-size: 1.454rem;
}
.mt {
  margin-top: 12px;
}
.listing-box {
  padding: 0;
}
.tomb-item .item-slide {
  background: #fff;
  border-radius: 10px;
  margin-bottom: 12px;
  margin-left: 12px;
  margin-right: 12px;
  display: flex;
}
.tomb-item .item-a {
  padding: 12px 1.363rem;
  position: relative;
  text-decoration: none;
}
.tomb-item .item-desc {
  -ms-flex-direction: column;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 10px;
  width: calc(100% - 8.909rem);
  margin-top: 0.5rem;
}
.tomb-item .item-desc .title {
  color: #333;
  font-size: 1.4rem;
  line-height: 1.4;
  margin-top: -3px;
  position: relative;
  padding: 0 !important;
}
.tomb-item .item-desc .intro-bot {
  -ms-flex-align: end;
  -ms-flex-pack: justify;
  -webkit-align-items: flex-end;
  -webkit-justify-content: space-between;
  align-items: flex-end;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}
.tomb-item .item-desc .intro-bot .pray-time {
  font-size: 1.1rem;
  color: #999;
}
.adm-infinite-scroll {
  color: var(--adm-color-weak);
  padding: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
}
</style>
